import clsx from 'clsx';
import type { KnownDetailType, KnownValue } from '../../types';
import KnownValueList from '../KnownValueList/KnownValueList';
import styles from './SourceValueRow.module.scss';

interface SourceValueRowProps {
    label?: string;
    subLabel?: string;
    values: KnownValue[];
    type: KnownDetailType;
    isInstance?: boolean;
}

const SourceValueRow = ({ label, subLabel, values, type, isInstance = false }: SourceValueRowProps) => (
    <>
        <div
            className={clsx(
                styles.SourceLabels,
                isInstance && styles.InstanceLabels,
                !isInstance && subLabel && styles.SourceLabelsStacked,
            )}
        >
            {label &&
                (isInstance ? (
                    <span className={styles.InstanceLabel} title={label}>
                        <span className={styles.InstanceBullet} aria-hidden="true">
                            •
                        </span>
                        <span className={styles.InstanceLabelText}>{label}</span>
                    </span>
                ) : (
                    <span className={styles.SourceLabel}>{label}</span>
                ))}
            {subLabel && <span className={clsx(styles.SourceSubLabel, isInstance && styles.InstanceSubLabel)}>{subLabel}</span>}
        </div>
        <KnownValueList values={values} type={type} />
    </>
);

export default SourceValueRow;
